// NoContentFound.tsx
import React from "react";

interface NoContentFoundProps {
  message?: string;
  height?: string | number;
  minHeight?: string | number;
  fill?: boolean;
}

export const NoContentFound: React.FC<NoContentFoundProps> = ({
  message = "No Content Found",
  height = "50vh",
  minHeight = "300px",
  fill = false,
}) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center w-100${
        fill ? " no-content-fill" : ""
      }`}
      style={{ height, minHeight }}
    >
      <div className="text-center">
        {/* <FileX size={64} className="text-muted mb-3" /> */}
        <p className="text-muted mb-0">{message}</p>
      </div>
    </div>
  );
};

export default NoContentFound;
